import "./style.scss";
import { env } from "../../environments/environment.js";

let mutationObserver;

export class Mealz {
  storeId;

  constructor(callback) {
    window.mealz.supplier.setupWithToken(env.carrefour.token);
    window.mealz.setDefaultScrollElementGetter(() => document.getElementsByTagName('html')[0])

    this.getUserId(userId => {
      this.handleLogin(userId).subscribe(() => {
        console.debug("[Miam injector] User logged in Mealz!");

        this.getCart((storeId, cart) => {
          console.debug("[Miam injector] Loaded storeID + cart -->", storeId, cart);
          window.mealz.pos.load(storeId)

          window.mealz.basketSync.definePushProductsToCart(this.pushProductsToBasket.bind(this));
          window.mealz.basket.initialize();
          window.mealz.hook.setHookCallback(this.hookCallback);
          this.sendCartToMealz(cart);

          callback();
        });
      });
    })
  }

  getUserId(callback) {
    callback(ONECF.getUserContext().userId);
  }

  handleLogin(userId) {
    console.debug("[Miam injector] Log user in Mealz...", userId);
    return window.mealz.user.loadWithExternalId(userId);
  }

  // handleLogout() {
  //   window.mealz.user.reset()
  // }

  getCart(callback) {
    console.debug("[Miam injector] Load Carrefour cart from API...");
    let url = `https://www.carrefour.fr/api/cart`;

    let req = new XMLHttpRequest();
    req.open("GET", url);
    req.setRequestHeader("x-requested-with", "XMLHttpRequest");
    req.onload = () => {
      let response = JSON.parse(req.responseText)
      let storeId = response.cart.facilityServiceId;
      if (!storeId) {
        return callback(null, []);
      }
      this.storeId = storeId;

      let categories = response?.cart.items;
      if (!categories || categories.length === 0) {
        return callback(storeId, []);
      }

      let cart = [];
      categories.forEach(c => {
        c.products.forEach(p => {
          let id = p?.product?.attributes?.ean;
          if (id && id.length > 0) {
            cart.push({ id: id, quantity: p.counter || 1 });
          }
        });
      });

      callback(storeId, cart);
    }
    req.send();
  }

  // { id: string, quantity: number, additionalInfos?: any}
  pushProductsToBasket(mealzProducts) {
    console.debug("[Miam injector] Push Mealz products to Carrefour", mealzProducts);

    this.getCart((storeId, cart) => {
      let data = mealzProducts.map(p => {
        let existingProduct = cart.find(item => item.id == p.id);
        let existingQty = existingProduct ? existingProduct.quantity : 0;
        let newQty = existingQty + p.quantity;
        return { ean: p.id, counter: newQty, basketServiceId: storeId };
      })
      window.ONECF.addToCart(data);
    });
  }

  sendCartToMealz(existingCart = null) {
    console.debug("[Miam injector] Send Carrefour cart to Mealz");

    if (existingCart) {
      window.mealz.basketSync.retailerBasketChanged(existingCart);
    } else {
      this.getCart((_storeId, cart) => {
        window.mealz.basketSync.retailerBasketChanged(cart);
      })
    }
  }

  // sendPaymentNotificationToMealz(cart) {
  //   window.mealz.basketSync.handlePayment(cart.price);
  // }

  hookCallback(isLogged, isPosValid) {
    if (!isPosValid) {
      // Navigate to 'Choose my Point of Sale' page
    }
    if (!isLogged) {
      // Navigate to login page
    }
    return isLogged && isPosValid;
  }
}

function initHeaderMutationObserver() {
  const mutationTarget = document.querySelector('html'); // element to watch
  const observedAtts = { attributes: true, childList: false, subtree: false };
  let lastHeaderHeight = 72;
  mutationObserver = new MutationObserver(() => {
    const htmlElement = document.querySelector('html');
    const newHeaderHeight = +getComputedStyle(htmlElement).getPropertyValue('--header-full-height').replace('px', '');
    if (lastHeaderHeight !== newHeaderHeight) {
      // Mobile
      if (window.innerWidth < 768) {
        let mobileHeaderHeight = +getComputedStyle(htmlElement).getPropertyValue('--header-height').replace('px', '')
        if (mobileHeaderHeight > lastHeaderHeight) mobileHeaderHeight += 40;
        lastHeaderHeight = mobileHeaderHeight;
        window.mealz.setStickyHeaderHeight(mobileHeaderHeight);
      } else { // Desktop
        window.mealz.setStickyHeaderHeight(lastHeaderHeight);
        lastHeaderHeight = newHeaderHeight;
      }
    }
  });
  mutationObserver.observe(mutationTarget, observedAtts);
}

let mealz = new Mealz(() => {
  // Start injection only after Mealz is ready

  listenToCartChanges();
  injectRecipeCards();
  injectMealzSpace();

  // To avoid multiple listener on same element
  if (mutationObserver == null) initHeaderMutationObserver();
});

function listenToCartChanges() {
  // Add / remove products to / from Carrefour cart
  document.addEventListener("onAddToCart", (e) => {
    mealz.sendCartToMealz();
  })

  // Click on "Remove all" button from cart drawer
  const oldPush = window.dataLayer.push;
  window.dataLayer.push = function (e) {
    if (e[0] === 'event' && e[1] === 'remove_from_cart' && e[2].event_action === 'remove_all_cart') {
      mealz.sendCartToMealz();
    }
    oldPush(e);
  }
}

function injectRecipeCards(attempt = 1) {
  if (!(location.href.match(/carrefour\.fr\/s(\?.*)?$/) || location.href.match(/carrefour\.fr\/r\/.*/))) {
    return;
  }

  const productsList = document.querySelector('.product-grid');
  if (!productsList || productsList.length === 0) {
    return setTimeout(() => injectRecipeCards(attempt + 1), 1000);
  }

  console.debug(`[Miam injector] Products list found in DOM (${attempt} attempts), injecting recipe cards...`);

  injectCardAtPosition(3);
  injectCardAtPosition(8);
  injectCardAtPosition(10);
  injectCardAtPosition(15);
}

// Position starts at 1 (elements in children array start at 0)
function injectCardAtPosition(i) {
  const productsList = document.querySelector('.product-grid');
  const cardContainer = document.createElement('li');
  cardContainer.classList.add('product-grid-item');

  cardContainer.style = `order: ${i};`;
  for (let index = i ; index < productsList.children.length ; index++) {
    productsList.children.item(index-1).style = `order: ${index+1};`;
  }

  const recipeCard = document.createElement('webc-miam-recipe-card');
  recipeCard.productIds = [
    { id: productsList.children.item(i-1).querySelector('article').id },
    { id: productsList.children.item(i).querySelector('article').id }
  ]
  recipeCard.style = "height: 100%; width: 100%;";
  cardContainer.appendChild(recipeCard);
  productsList.insertBefore(cardContainer, productsList.children.item(i-1));

  console.debug('[Miam injector] Injected recipe card at position -->', i, recipeCard.productIds);
}


function injectMealzSpace(attempt = 1) {
  if (!location.href.includes("/recette")) {
    return;
  }

  const page = document.querySelector('carrefour-recipes');
  if (!page) {
    return setTimeout(() => injectRecipeCards(attempt + 1), 1000);
  }

  console.debug(`[Miam injector] Recipes page found (${attempt} attempts), injecting catalog...`);

  const mealzSpace = document.createElement('webc-miam-recipe-catalog');
  mealzSpace.style = "width: 100%;";
  page.parentNode.replaceChild(mealzSpace, page);
}
